<template>
  <div style="flex-direction:column;">
    <!-- 订单内容 -->
    <div style="width:100%;justify-content: center;margin-top:.2rem;">
      <div :style="{backgroundImage:'url('+baUrl+')'}" class="backetc"
           @click="routerOrderEtc">
        <div style="height:100%;align-items:center;width:95%;justify-content:center;">
          <div style="flex-direction:column;text-align:left;width:1.26rem;">
            <div style="font-size:.18rem;font-weight:bold;color:#333333;">电子照</div>
            <div style="font-size:.14rem;font-weight:normal;color:#999999;">拍摄的电子照片</div>
          </div>
        </div>
        <div class="img-div">
          <img class="arrow"
               src="@/assets/arrow.png" />
        </div>
      </div>
    </div>
    <div style="width:100%;justify-content: center;margin-top:.2rem;">
      <div :style="{backgroundImage:'url('+bbUrl+')'}" class="backprint"
           @click="routerOrderPrint">
        <div style="height:100%;align-items:center;width:95%;justify-content:center;">
          <div style="flex-direction:column;text-align:left;1.26rem;">
            <div style="font-size:.18rem;font-weight:bold;color:#333333;">冲印照</div>
            <div style="font-size:.14rem;font-weight:normal;color:#999999;">打印的快递订单照片</div>
          </div>
        </div>
        <div class="img-div">
          <img class="arrow"
               src="@/assets/arrow.png" />
        </div>
      </div>
    </div>
    <!-- <mt-tabbar v-model="selected"
               :fixed='true'>
      <mt-tab-item id="home">
        <img slot="icon"
             src="../assets/index.png">
        首页
      </mt-tab-item>
      <mt-tab-item id="order">
        <img slot="icon"
             src="../assets/order2.png">
        订单
      </mt-tab-item>
      <mt-tab-item id="customerService">
        <img slot="icon"
             src="../assets/mask2.png">
        客服
      </mt-tab-item>
    </mt-tabbar> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(['platformInfo'])
  },
  data () {
    return {
      selected: 'order',
      imgUrl: 'background-image: url(../assets/order_form_image@3x.png)',
      baUrl:'',
      bbUrl:''
    }
  },
  created(){
    this.baUrl = require('@/assets/skins/'+this.platformInfo.skin+'/order_photo_image@3x.png')
    this.bbUrl = require('@/assets/skins/'+this.platformInfo.skin+'/order_form_image@3x.png')
  },
  methods: {
    routerOrderEtc () {
      this.$router.push('/orderEtc');
    },
    routerOrderPrint () {
      this.$router.push('/OrderList');
    }
  },
  watch: {
    selected: function (val, oldVal) {
      switch (val) {
        case 'home':
          this.$router.replace({ name: 'home' });
          break;
        case 'orderList':
          this.$router.replace({ name: "order" });
          break;
        case 'customerService':
          this.$router.replace('/customerService');
          break;
      }
    }
  },
}
</script>

<style scoped>
.mint-tabbar .mint-tab-item.is-selected {
  background-color: #f9f9f9 !important;
  color: #333333 !important;
}
.mint-tabbar .mint-tab-item {
  background-color: #f9f9f9 !important;
  color: #a3a5ab !important;
}
.img-div {
  height: 100%;
  /* width: 0.5rem; */
  align-items: center;
  justify-content: center;
}
.backetc {
  width: 3.55rem;
  height: 1.05rem;
  /* background-image: url(../assets/order_photo_image@3x.png); */
  background-size: 100% 100%;
}
.backprint {
  width: 3.55rem;
  height: 1.05rem;
  /* background-image: url(../assets/order_form_image@3x.png); */
  background-size: 100% 100%;
}
div {
  display: flex;
}
.arrow {
  height: 0.12rem;
  width: 0.07rem;
  margin-right: 0.2rem;
  justify-content: flex-end;
}
</style>
